import keycloak from './keycloak'

export default async function doWebLogin() {
  if (keycloak.tokenParsed) return

  await keycloak.login({})
}
